"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasetListSchema = exports.DatasetObjectSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const typeSchema_1 = require("../type/typeSchema");
exports.DatasetObjectSchema = zod_1.default.object({
    dataset: zod_1.default.object({
        id: zod_1.default.number(),
        slug: zod_1.default.string(),
        name: zod_1.default.string(),
        plugin: zod_1.default.string(),
        // tags: z.array(DatasetTagDto),
        data: zod_1.default.object({
            kind: zod_1.default.literal('physical'),
            ingest_types: zod_1.default.array(zod_1.default.unknown()),
            columns: zod_1.default.array(zod_1.default.object({
                type: typeSchema_1.TypeSchema,
                name: zod_1.default.string(),
                note: zod_1.default.string().nullable().default(null),
                description: zod_1.default.string().nullable(),
                title: zod_1.default.string(),
                flags: zod_1.default.array(zod_1.default.enum([
                    'asset',
                    'time_partition',
                    'dimension',
                    'required',
                    'activity',
                ])),
            })),
        }),
    }),
});
exports.DatasetListSchema = zod_1.default.object({
    data: zod_1.default.array(exports.DatasetObjectSchema),
});
//# sourceMappingURL=datasetSchema.js.map